module.exports = __webpack_public_path__ + "static/media/54_Print.05e8c1c7.png";